/**
 * Once-per-card-per-session PostHog emit for Soren Home ranking.
 * Staging has no PostHog key — track() no-ops. Tests assert the emit call.
 */
import { track } from '../../lib/track'

export const IMPRESSION_KIND: Record<string, string> = {
  cash_delta: 'delta',
  cadence: 'cadence',
  retainage: 'retainage',
  friday_checkin: 'friday_cash',
  commitment_stale: 'commitment_stale',
  prediction: 'prediction',
}

const shown = new Set<string>()

export function impressionKey(card: { id?: string; kind?: string; projectId?: number }): string {
  return `${card.kind || 'card'}:${card.id || ''}:${card.projectId ?? ''}`
}

export function emitSorenCardShown(
  card: { id?: string; kind?: string; projectId?: number; weekOf?: string },
  trackFn: typeof track = track,
): boolean {
  const mapped = card.kind ? IMPRESSION_KIND[card.kind] : null
  if (!mapped) return false
  const key = impressionKey(card)
  if (shown.has(key)) return false
  shown.add(key)
  const props: Record<string, string | number | boolean> = { card_kind: mapped }
  if (card.projectId) props.project_id = card.projectId
  if (card.weekOf) props.week_of = card.weekOf
  trackFn('soren_card_shown', props)
  return true
}

export function emitSorenCardsShown(
  cards: Array<{ id?: string; kind?: string; projectId?: number; weekOf?: string }>,
  trackFn: typeof track = track,
): number {
  let n = 0
  for (const card of cards) {
    if (emitSorenCardShown(card, trackFn)) n += 1
  }
  return n
}

/** Test helper */
export function resetSorenImpressionsForTests(): void {
  shown.clear()
}
